import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Check if Firebase environment variables are configured
const isFirebaseConfigured = () => {
  return process.env.REACT_APP_FIREBASE_API_KEY && 
         process.env.REACT_APP_FIREBASE_PROJECT_ID;
};

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || 'demo-api-key',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 'demo-project.firebaseapp.com',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || 'demo-project',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'demo-project.appspot.com',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '123456789',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || 'demo-app-id',
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 'demo-measurement-id'
};

let app;
let auth;
let db;
let analytics;
let isInitialized = false;

// Initialize Firebase only if properly configured
if (isFirebaseConfigured() && !isInitialized) {
  try {
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);
    
    // Only initialize analytics in production
    if (process.env.NODE_ENV === 'production') {
      analytics = getAnalytics(app);
    }
    
    isInitialized = true;
  } catch (error) {
    // Fall back to demo mode
    // Fall back to demo mode
    app = null;
    auth = null;
    db = null;
    analytics = null;
  }
} else if (isInitialized) {
  // Firebase already initialized
} else {
  // Firebase not configured, running in demo mode
  
  // Create mock Firebase services for development
  app = {
    name: 'demo-app',
    options: firebaseConfig
  };
  
  auth = {
    currentUser: null,
    onAuthStateChanged: (callback) => {
      callback(null);
      return () => {};
    },
    signOut: async () => Promise.resolve(),
    // Add other mock methods as needed
  };
  
  db = {
    collection: () => ({
      doc: () => ({
        set: async () => Promise.resolve(),
        get: async () => Promise.resolve({ exists: false, data: () => ({}) }),
        update: async () => Promise.resolve()
      }),
      add: async () => Promise.resolve({ id: 'demo-id' }),
      where: () => ({
        orderBy: () => ({
          limit: () => ({
            get: async () => Promise.resolve({ empty: true, docs: [] })
          })
        })
      })
    })
  };
  
  analytics = {
    logEvent: () => {},
    setUserId: () => {},
    setUserProperties: () => {}
  };
}

// Connect to Firebase emulators in development if available
if (process.env.NODE_ENV === 'development' && isFirebaseConfigured()) {
  try {
    // Check if emulators are running
    if (process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true') {
      connectAuthEmulator(auth, 'http://localhost:9099');
      connectFirestoreEmulator(db, 'localhost', 8080);
      // Connected to Firebase emulators
    }
  } catch (error) {
    // Firebase emulators not available
  }
}

// Export Firebase services
export { auth, db, analytics };
export default app;
